import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'

interface RouteDebuggerProps {
  enabled?: boolean
}

export function RouteDebugger({ enabled = false }: RouteDebuggerProps) {
  const location = useLocation()
  const params = useParams()

  useEffect(() => {
    if (!enabled) return

    console.group('🔍 Route Debugger')
    console.log('Current path:', location.pathname)
    console.log('Search params:', location.search)
    console.log('Route parameters:', params)
    console.groupEnd()
  }, [location, params, enabled])

  if (!enabled) return null

  return (
    <div className="fixed bottom-4 right-4 bg-black/80 text-white p-4 rounded-lg text-xs z-50 max-w-md">
      <h3 className="font-bold mb-2">Route Debugger</h3>
      <div>
        <p><strong>Path:</strong> {location.pathname}</p>
        <p><strong>Search:</strong> {location.search || '(none)'}</p>
        <p><strong>Params:</strong> {JSON.stringify(params)}</p>
      </div>
    </div>
  )
}
